import middlewares from './middlewares';

export default (router) => {
    middlewares.forEach(middleware => middleware(router));
};



// WEBPACK FOOTER //
// ./src/router/applyMiddlewares.js